import { Component ,ElementRef, ViewChild} from '@angular/core';
import { IonicPage, NavController, NavParams, Item } from 'ionic-angular';

/**
 * Generated class for the FichadaDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var google;

@IonicPage()
@Component({
  selector: 'page-fichada-detalle',
  templateUrl: 'fichada-detalle.html',
})
export class FichadaDetallePage {
  item = {Fecha : null, Ficha : null, Nombre : null, Entradas : [], Salidas : []};
  latitud : 39.19;
  longitud : 0.43;

  @ViewChild('map') mapElement: ElementRef; 
  map: any;



  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.item = navParams.data.item;
  // alert(this.item.Fecha);
  }
  
  loadMap(){
    var bounds = new google.maps.LatLngBounds();

    let i : number;
    let j : number;
    let aux : number;
    i = 0; j = 0; aux = 0;
    //console.log('loadMap()');
    // create a new map by passing HTMLElement
    let mapEle: HTMLElement = document.getElementById('map');

    let myLatLng = {lat: this.item.Entradas[0].latitud, lng: this.item.Entradas[0].longitud};
    // create LatLng object
    if (this.item.Entradas[0].latitud == 0 )
      myLatLng = {lat: this.item.Salidas[0].latitud, lng: this.item.Salidas[0].longitud};
  
    // create map
    this.map = new google.maps.Map(mapEle, {
      center: myLatLng,
      zoom: 10,
    });
  
  // Add multiple markers to map
  var infoWindow = new google.maps.InfoWindow();//, marker, i;
  var infoWindowContent = [];
    //********** Markers de ENTRADAS
    for( i = 0; i < this.item.Entradas.length; i++ ) {
      if(this.item.Entradas[i].latitud != 0 )
      {
        infoWindowContent.push('<h3>' + this.item.Entradas[i].hora + ' &nbsp</h3> <br>');
        //console.log(this.item.Entradas[i].hora);
        var position = new google.maps.LatLng(this.item.Entradas[i].latitud, this.item.Entradas[i].longitud);
        bounds.extend(position);
        
        let marker = new google.maps.Marker({
            position: position,
            map: this.map,
            title: this.item.Entradas[i].hora
        });

        // Add info window to marker    
        google.maps.event.addListener(marker, 'click', (function(marker, i) {
          return function() {
              infoWindow.setContent(infoWindowContent[i]);
              infoWindow.open(this.map, marker);
          }
        })(marker, i));
    }
    }
    if(this.item.Entradas[0].latitud == 0 ) i = 0;
    //*********** Markers de SALIDAS
    for( j = 0; j < this.item.Salidas.length; j++ ) {
      if(this.item.Salidas[j].latitud != 0 )
      {
        infoWindowContent.push('<h3>' + this.item.Salidas[j].hora + ' &nbsp</h3> <br>');

        //console.log(this.item.Salidas[j].hora);
        var position = new google.maps.LatLng(this.item.Salidas[j].latitud, this.item.Salidas[j].longitud);
        bounds.extend(position);
        let marker = new google.maps.Marker({
            position: position,
            map: this.map,
            title: this.item.Salidas[j].hora
        });
        aux = i + j;
        // Add info window to marker    
        google.maps.event.addListener(marker, 'click', (function(marker, aux) {
          return function() {
              infoWindow.setContent(infoWindowContent[aux]);
              infoWindow.open(this.map, marker);
          }
        })(marker, aux));
    }
    }

      // Center the map to fit all markers on the screen
     // console.log(aux);
      if (aux > 0){ 
        this.map.fitBounds(bounds);
      }
      mapEle.classList.add('show-map');
      //alert(j+i);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FichadaDetallePage');
  }

  ionViewWillEnter() {
    this.loadMap();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fichada-detalle/fichada-detalle.ts